@if(tankInfo) {
  <div class="main-div" #tankCard (mouseenter)="showTooltip()" (click)="showTooltip(true)">
    <p class="tank-number">{{ 'fuelShared.tankCard.tankNumber' | transloco: { number: tankNo } }}</p>
    <div
      class="inner-div"
      [class.increase]="tankInfo.tankType === 'increase'"
      [class.decrease]="tankInfo.tankType === 'decrease'"
      [class.verylow]="tankInfo.tankType === 'verylow'"
      [class.disabled]="tankInfo.tankType === 'disabled'"
    >
      <div class="color-div"></div>
      <div class="text-wrap">
        <div class="d-flex justify-content-between align-items-center">
          <p class="percentage">{{ tankInfo.percentage }}</p>
          <p class="quantity">{{ tankInfo.volume }}</p>
        </div>
      </div>
      <img src="assets/images-fuel/tankScale.svg" alt="tankScale" class="tank-scale" />
    </div>
  </div>
  }
